<app-modal-frame
  [headerText]="CONSTS.HEADER"
  [rightButton]="{
    type: BUTTON_TYPES.REPORT_BUTTON,
  }"
  (emitExit)="onExit()"
  (emitRightClick)="getReport()"
>
  <form
    class="aged-package-status-container"
    [formGroup]="agedPackageStatusForm"
  >
    <ion-row>
      <ion-col
        size="12"
        size-sm="6"
        size-md="6"
        size-lg="6"
        size-xl="12"
      >
        <app-form-select
          formControlName="routes"
          [label]="CONSTS.ROUTE_LABEL"
          [options]="routes"
          [customClass]="'scan-type-dropdown report-select'"
        ></app-form-select>
      </ion-col>
      <ion-col
        size="12"
        size-sm="6"
        size-md="6"
        size-lg="6"
        size-xl="12"
      >
        <app-report-format
          [radioButtonValue]="agedPackageStatusForm.get('reportFormat')?.value"
          (emitRadioChange)="radioChange($event)"
        ></app-report-format>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <app-download-note numRows="2,000"> </app-download-note>
      </ion-col>
    </ion-row>
  </form>
</app-modal-frame>
<app-pdf-report-generator
  #pdfContainer
  [hidden]="true"
  [columns]="PDF_REPORT.COLUMNS"
  [columnsData]="
    agedPackageStatusReport &&
    agedPackageStatusReport.response.agedPackageStatus
  "
  [dataFields]="PDF_REPORT.DATA_FIELDS"
  [hasSingleSubHeaderView]="false"
  [dataRowHeight]="37"
  [columnWidths]="[85, 155, 50, 115, 135, 95, 50, 95]"
>
  @if (agedPackageStatusReport && agedPackageStatusReport.response) {
    <ng-container sub-header>
      <table
        aria-hidden="true"
        class="pdf-sub-header-table"
      >
        <tr class="pdf-sub-header-row">
          <td>
            {{ PDF_REPORT.HEADER.LOOP }}
            {{ agedPackageStatusReport.response.loop }}
          </td>
          <td>
            {{ PDF_REPORT.HEADER.LOCATION }}
            {{ agedPackageStatusReport.response.location }}
          </td>
        </tr>
      </table>
    </ng-container>
  }
</app-pdf-report-generator>
